module.exports = __webpack_public_path__ + "static/sounds/tixing.3ab85bc.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/tixing.wav
// module id = 455
// module chunks = 1 2 3 4 5 6 7 8